import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { useSearchParams, useParams, useLocation } from 'react-router-dom'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../../layouts/TextStyles'
import SubjectAnalyticsTable from './components/SubjectAnalyticsTable'
import { subjectApiSlice } from '../../../../features/subject/subjectSlice'
import { capitalize } from '../../../../utils/functions'

const SubjectAnalyticsPage = () => {
    const { locale } = useIntl()
    const { courseId } = useParams()
    const { state } = useLocation()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(+searchParams.get('page') || 1)
    const [rowsPerPage, setRowsPerPage] = React.useState(
        +searchParams.get('size') || 5,
    )
    const {
        data: analyticsResponse = null,
        isFetching,
    } = subjectApiSlice.useFetchAnalyticsQuery({
        page: +page - 1,
        size: +rowsPerPage,
        courseId: Number(courseId)
    })

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
        }
        setSearchParams(params, { state })
    }, [rowsPerPage, page])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {state?.course?.[`courseTitle${capitalize(locale)}`] || "Пән"} аналитикасы</H3>
                    </Title>
                </Header>

                {isFetching ? (
                    <LinearProgress />
                ) : (
                    analyticsResponse && (
                        <SubjectAnalyticsTable
                            isFetching={isFetching}
                            analyticsData={analyticsResponse?.data}
                            pageNumber={analyticsResponse?.pageNumber}
                            totalCount={analyticsResponse?.totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}

export default SubjectAnalyticsPage


const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`